module.exports = __webpack_public_path__ + "media/images/icons/change_password-11bb8da727ef2876d1923bff8d76b13a.svg";